import { Globe2 } from 'lucide-react';
import { CollectionAdmin } from './_P1Common';

export default function AdminCompetitorTracking() {
  return (
    <CollectionAdmin
      path="competitor-tracking"
      title="Praćenje konkurencije"
      subtitle="Portali koje pratimo radi usporedbe sadržaja"
      icon={Globe2}
      testid="admin-competitor-tracking"
      fields={[
        { key: 'name', label: 'Naziv portala' },
        { key: 'url', label: 'URL' },
        { key: 'rss_url', label: 'RSS URL' },
        { key: 'category', label: 'Kategorija' },
        { key: 'note', label: 'Bilješka', type: 'textarea' },
        { key: 'active', label: 'Aktivan', type: 'checkbox' },
      ]}
    />
  );
}
